<template>
  <div id="GoTop">
    <div class="pcend hidden-xs">
      <div class="moveend-body">
        <el-popover
          placement="left"
          trigger="hover"
          :close-delay="100"
        >
          <div class="contactus">
            <p>
              {{$t('home.address')}}：{{ contactUs.address }}
            </p>
            <p>
              {{$t('home.telephone')}}：{{ contactUs.telephone  }}
            </p>
            <p>
              {{$t('home.cellphone')}}：{{ contactUs.cellPhone }}</p>

            <p>
              {{$t('home.mailbox')}}：{{  contactUs.mailbox }}
            </p>
            <p>
              {{  contactUs.name }}
            </p>
          </div>
          <div
            slot="reference"
            class="el-icon"
          >
            <i class="el-icon-phone"></i>
          </div>
        </el-popover>
        <el-popover
          placement="left"
          trigger="hover"
          :close-delay="100"
        >
          <div class="weixin-img">

            <div
              v-for="(item, index) in imgList"
              :key="index"
            >
              <div>
<!--                <vue-qr-->
<!--                  ref="qrCode"-->
<!--                  :text="item.text"-->
<!--                  :size="160"-->
<!--                  :logoSrc="item.logoSrc"-->
<!--                  :logoCornerRadius="2"-->
<!--                  :logoMargin="4"-->
<!--                  :margin="14"-->
<!--                ></vue-qr>-->

                <img :src="item.qrCode"/>
                <div>{{item.name}}</div>

              </div>
              <span>
                {{ item.title }}
              </span>
            </div>

          </div>
          <div
            slot="reference"
            class="el-icon"
          >
            <i class="iconfont kai-icon-weixin"></i>
          </div>
        </el-popover>

        <div
          class="el-icon"
          @click="subEdit"
        >
          <img style="width: 80%;margin-bottom: 5px"  src="../assets/img/fj.png">
        </div>
        <div
          class="el-icon"
          @click="GoTop()"
        >
          <span class="glyphicon glyphicon-chevron-up"></span>
        </div>
      </div>
      <!-- <div class="moveend-bot">
        <div class="el-icon">
          <i class="el-icon-plus"></i>
        </div>

      </div> -->
    </div>
    <div>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr';
import api from "../api/api";
export default {
  name: "GoTop",
  components: {
    VueQr
  },
  data() {
    return {
      flag: false,
      contactUs:
      {
        phone1: '816-3608',
        phone2: 'GLOBE- 0917-958-6999 0927-421-7388',
        address: 'Unit 403 Diplomat Condominiu, Roxas BLVD. Corner, Russel St. Pasay City',
        email: 'cyxmanpowerserviceinc@gmail. com'
      },
      imgList: [  ],
      dialogFormVisible: false
    };
  },
  created() {
    this.getUsInfo()
    this.getQr()
  },
  methods: {
    getQr(){
      api.selectQrCodeList({language: this.$store.state.lang}).then(res =>{
        this.imgList = res.data.data
      })
    },
    getUsInfo(){
      api.getUs().then(res => {
        if( res.data.data &&  res.data.data.length > 0 ){
          this.contactUs = res.data.data[0]
        }
      })
    },
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },
    subEdit() {
      this.dialogFormVisible = true;
      this.$store.commit('setDialogFormVisible', true);
    }
  }
};
</script>
<style scoped >
#GoTop {
  width: 60px;
  position: fixed;
  right: 0px;
  bottom: 20%;
  padding: 5px 0;
  transform: translate(0, -50%);
  z-index: 99999999;
  cursor: pointer;
  border: 1px solid #02061f54;
  background: #ffffff;
  /* box-shadow: 0px 0px 1px 1px #02061f54; */
}

.moveend-body {
  /* height: 100px ; */
  /* visibility: hidden; */
}

.el-icon {
  padding-left: 14px;
  font-size: 35px;
  /*color: #0a1769d4;*/
  color: #196fc5;
  padding-top: 5px;
}

.el-icon:hover {
  /*color: #304af5;*/
  color: #196fc5;
}

#GoTop > span {
  display: block;
  /* width: 100%;
  height: 100%; */
  /* font-size: 30px; */
}

.weixin-img {
  display: flex;
}
.weixin-img > div {
  text-align: center;
}
.weixin-img > div > div {
  border: 1px solid #25252542;
  border-radius: 4px;
  margin: 0 5px 5px;
}

.contactus {
  /* width: 340px; */
  /* height: 150px; */
}
@media screen and (max-width: 997px) {
  #GoTop {
    width: 30px;

    /* border-radius: 50px; */
  }

  .moveend-body {
    padding-top: 5px;
    /* height: 0;
    visibility: hidden; */
  }

  .moveend-bot {
    /* padding-top: 3px; */
  }

  .iconfont {
    font-size: 20px;
  }

  .el-icon {
    padding-left: 5px;
    font-size: 20px;
    color: #0a1769d4;
  }
}
@media screen and (max-width: 768px) {
  #GoTop{
    width: 0;
    height: 0;
    /* overflow: hidden; */
    border:0
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue